var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.167,
    cy: 10,
    r: 10,
    fill: "#B5B5B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3762 5.20921C5.65515 4.93026 6.10741 4.93026 6.38635 5.20921L10.167 8.98985L13.9476 5.20921C14.2266 4.93026 14.6788 4.93026 14.9578 5.20921C15.2367 5.48816 15.2367 5.94042 14.9578 6.21936L11.1771 10L14.9578 13.7806C15.2367 14.0596 15.2367 14.5118 14.9578 14.7908C14.6788 15.0697 14.2266 15.0697 13.9476 14.7908L10.167 11.0102L6.38635 14.7908C6.10741 15.0697 5.65515 15.0697 5.3762 14.7908C5.09726 14.5118 5.09726 14.0596 5.3762 13.7806L9.15684 10L5.3762 6.21936C5.09726 5.94042 5.09726 5.48816 5.3762 5.20921Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDelete);
export default __webpack_public_path__ + "static/media/searchDelete.b09608ea474a6b77d6c404aa5b085d09.svg";
export { ForwardRef as ReactComponent };